/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Typography, Box, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from "@material-ui/core/Button";
import { ToastContainer, toast } from 'react-toastify';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import CSVReader from 'react-csv-reader';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import SearchNotFound from '../../../SearchNotFound';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function SurplusBulkUpload(props) {

  const navigate = useNavigate();
  const screenCode = 'SURPLUSBULKUPLOAD';
  const [isUploadButtonEnable, setIsUploadButtonEnable] = useState(true);
  const [isTableEnable, setIsTableEnable] = useState(true);
  const [farmersCSVData, setFarmersCSVData] = useState([]);
  const [isFileChosen, setIsFileChosen] = useState(false);
  const [fileInfo, setFileInfo] = useState({});
  const [weeks1, setWeeks1] = useState([]);
  const [surplusBulkUpload, setSurplusBulkUpload] = useState([]);

  const getMondayOfCurrentWeek = () => {
    const today = dayjs();
    const dayOfWeek = today.day();
    const monday = today.subtract(dayOfWeek - 1, 'day'); 
    return monday;
  };

  const [Datevalue, setDateValue] = useState(getMondayOfCurrentWeek());
  const [currentMonday, setCurrentMonday] = useState(getMondayOfCurrentWeek());

  const handleDateChange = (newValue) => {
    setDateValue(newValue);
    const weeks = calculateWeeks(newValue);
    setWeeks1(weeks);
  };

  const shouldDisableDate = (date) => {
    const day = date.day();
    const today = dayjs();
    const isCurrentWeekMonday = date.isSame(currentMonday, 'day');
    return day !== 1 || (date.isBefore(today, 'day') && !isCurrentWeekMonday);
  };

  const calculateWeeks = (date) => {
    if (!date) return [];
    const yearAhead = new Date(date);
    yearAhead.setFullYear(yearAhead.getFullYear() + 1);
    const startDate = new Date(date);
    const endDate = new Date(yearAhead);

    const weeks = [];
    while (startDate < endDate) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        if (startDate <= endDate) {
          week.push(new Date(startDate).toDateString());
          startDate.setDate(startDate.getDate() + 1);
        }
      }
      weeks.push(week);
    }
    return weeks;
  };

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T', 1)
  });

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: false,
    submitButtonName: "Upload",
    pageheadername: "Surplus Bulk Upload"
  });

  const ProductSaveSchema = Yup.object().shape({
    date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
  });

  const formik = useFormik({
    initialValues: {
      date: formData.date
    },

    validationSchema: ProductSaveSchema,
    onSubmit: (values) => {
      if (pageProps.isEdit > 0) {
        UpdateProduct(values, pageProps.editingID)
      } else {
        trackPromise(SaveSurplusBulkUpload());
      }
    },
  });

  const { handleSubmit } = formik;

  useEffect(() => {
    setSurplusBulkUpload([]);
    setIsTableEnable(true);
    clearAll();
  }, [Datevalue]);

  useEffect(() => {
    calculateWeeks(Datevalue);
  }, [Datevalue]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - surplusBulkUpload.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  async function SaveSurplusBulkUpload() {
    
    const hasNaNValues = surplusBulkUpload.some(surplus =>
      Object.values(surplus).some(value => Number.isNaN(value))
    );

    if (hasNaNValues) {
      toast.error('Empty or Invalid characters are not allowed. Please fill in all the data with valid characters and try again.');
      return;
    }

    const hasNegativeValue = surplusBulkUpload.some(surplus => {
      return Object.values(surplus).some(value => typeof value === 'number' && value < 0);
    });

    if (hasNegativeValue) {
      toast.error('Negative values are not allowed. Please correct the data and try again.');
      return;
    }

    var res = await services.SaveSurplusBulkUpload(surplusBulkUpload);
    if (res.statusCode === 'Success') {
      toast.success(res.message);
      clearAll();
      setDateValue(getMondayOfCurrentWeek());
    } else {
      toast.error(res.message);
    }
  }



  async function assginMarket(data, type) {

    if (type.type === "text/csv") {
      setSurplusBulkUpload([]);
      const datarest = await Promise.all(data.map(async data => {
        const weeks = Array.from({ length:52}, (_, i) => `week${i + 1}`).reduce((acc, week) => {
          const value = parseFloat(data[week]);
          acc[week] = value < 0 ? `red:${value}` : value;
          return acc;
        }, {});

        var surplusDetails = {
          date: new Date(Datevalue),
          productName: data.productName,
          productCode: data.productCode,
          week1: parseFloat(data.week1) ,
          week2: parseFloat(data.week2) ,
          week3: parseFloat(data.week3) ,
          week4: parseFloat(data.week4) ,
          week5: parseFloat(data.week5) ,
          week6: parseFloat(data.week6) ,
          week7: parseFloat(data.week7) ,
          week8: parseFloat(data.week8) ,
          week9: parseFloat(data.week9) ,
          week10: parseFloat(data.week10) ,
          week11: parseFloat(data.week11) ,
          week12: parseFloat(data.week12) ,
          week13: parseFloat(data.week13) ,
          week14: parseFloat(data.week14) ,
          week15: parseFloat(data.week15) ,
          week16: parseFloat(data.week16) ,
          week17: parseFloat(data.week17) ,
          week18: parseFloat(data.week18) ,
          week19: parseFloat(data.week19) ,
          week20: parseFloat(data.week20),
          week21: parseFloat(data.week21) ,
          week22: parseFloat(data.week22) ,
          week23: parseFloat(data.week23) ,
          week24: parseFloat(data.week24) ,
          week25: parseFloat(data.week25) ,
          week26: parseFloat(data.week26) ,
          week27: parseFloat(data.week27) ,
          week28: parseFloat(data.week28) ,
          week29: parseFloat(data.week29) ,
          week30: parseFloat(data.week30) ,
          week31: parseFloat(data.week31) ,
          week32: parseFloat(data.week32) ,
          week33: parseFloat(data.week33) ,
          week34: parseFloat(data.week34) ,
          week35: parseFloat(data.week35) ,
          week36: parseFloat(data.week36) ,
          week37: parseFloat(data.week37) ,
          week38: parseFloat(data.week38) ,
          week39: parseFloat(data.week39) ,
          week40: parseFloat(data.week40),
          week41: parseFloat(data.week41) ,
          week42: parseFloat(data.week42) ,
          week43: parseFloat(data.week43) ,
          week44: parseFloat(data.week44) ,
          week45: parseFloat(data.week45) ,
          week46: parseFloat(data.week46) ,
          week47: parseFloat(data.week47) ,
          week48: parseFloat(data.week48) ,
          week49: parseFloat(data.week49) ,
          week50: parseFloat(data.week50) ,
          week51: parseFloat(data.week51) ,
          week52: parseFloat(data.week52) ,


          createdBy: parseInt(TokenDecoder.getUserIDFromToken())
        }
        setSurplusBulkUpload(surplusBulkUpload => [...surplusBulkUpload, surplusDetails]);
        setIsTableEnable(false)
      }))

      var errorList = [];
      datarest.map((itemx) => {
        if (itemx != undefined) {
          errorList.push(itemx);
        }
      })
      setFarmersCSVData(errorList);
    }

    else {
      toast.error(type.name + " is not valid . please select a CSV file.");
      setTimeout(() => {
      }, 3000);
    }
  }

  function duplicateCheck() {
    let newRes = _.cloneDeep(surplusBulkUpload);
    var result = [];
    var duplicates = [];
    newRes.forEach(x => {

      var duplicateSurplus = result.find(y => y.marketCode === x.marketCode && y.productCode === x.productCode);
      if (duplicateSurplus != undefined) {
        duplicates.push(duplicateSurplus);
      }
      result.push(x);
    });
    return duplicates;
  }

  async function clearAll() {
    var surplusDetails = {
      productName: "",
      productCode: "",
      date: Datevalue,
      marketCode: "",
      marketName: "",
      minPrice: 0,
      maxPrice: 0,
    }
    setSurplusBulkUpload([surplusDetails]);
    setIsFileChosen(false);
    setIsUploadButtonEnable(true);
    setIsTableEnable(true)
    document.querySelector('.csv-input').value = '';
  }

  const papaparseOptions = {
    header: true,
    dynamicTyping: false,
    quoteChar: '"',
    skipEmptyLines: true,
    parseNumbers: true,
    transformHeader: header => header.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '')
  };

  const handleForce = (data, fileInfo) => {
   
    setIsFileChosen(true);
    setFileInfo(fileInfo);
    assginMarket(data, fileInfo);
    confirmUpload(data, fileInfo);
    
  }

  function confirmUpload(data, fileInfo) {
    setFarmersCSVData(data);
  }

  useEffect(() => {
    getPermissions();
    handleDateChange(currentMonday);
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSURPLUSBULKUPLOAD');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });
  }

  const csvHeaders = [
    { label: "productName", key: "productName" },
    { label: "productCode", key: "productCode" },
    { label: "Week1", key: "Week1" },
    { label: "Week2", key: "Week2" },
    { label: "Week3", key: "Week3" },
    { label: "Week4", key: "Week4" },
    { label: "Week5", key: "Week5" },
    { label: "Week6", key: "Week6" },
    { label: "Week7", key: "Week7" },
    { label: "Week8", key: "Week8" },
    { label: "Week9", key: "Week9" },
    { label: "Week10", key: "Week10" },
    { label: "Week11", key: "Week11" },
    { label: "Week12", key: "Week12" },
    { label: "Week13", key: "Week13" },
    { label: "Week14", key: "Week14" },
    { label: "Week15", key: "Week15" },
    { label: "Week16", key: "Week16" },
    { label: "Week17", key: "Week17" },
    { label: "Week18", key: "Week18" },
    { label: "Week19", key: "Week19" },
    { label: "Week20", key: "Week20" },
    { label: "Week21", key: "Week21" },
    { label: "Week22", key: "Week22" },
    { label: "Week23", key: "Week23" },
    { label: "Week24", key: "Week24" },
    { label: "Week25", key: "Week25" },
    { label: "Week26", key: "Week26" },
    { label: "Week27", key: "Week27" },
    { label: "Week28", key: "Week28" },
    { label: "Week29", key: "Week29" },
    { label: "Week30", key: "Week30" },
    { label: "Week31", key: "Week31" },
    { label: "Week32", key: "Week32" },
    { label: "Week33", key: "Week33" },
    { label: "Week34", key: "Week34" },
    { label: "Week35", key: "Week35" },
    { label: "Week36", key: "Week36" },
    { label: "Week37", key: "Week37" },
    { label: "Week38", key: "Week38" },
    { label: "Week39", key: "Week39" },
    { label: "Week40", key: "Week40" },
    { label: "Week41", key: "Week41" },
    { label: "Week42", key: "Week42" },
    { label: "Week43", key: "Week43" },
    { label: "Week44", key: "Week44" },
    { label: "Week45", key: "Week45" },
    { label: "Week46", key: "Week46" },
    { label: "Week47", key: "Week47" },
    { label: "Week48", key: "Week48" },
    { label: "Week49", key: "Week49" },
    { label: "Week50", key: "Week50" },
    { label: "Week51", key: "Week51" },
    { label: "Week52", key: "Week52" },
  ];

  const csvData = [
    {
      productName: "", productCode: "", Week1: "", Week2: "", Week3: "", Week4: "", Week5: "", Week6: "", Week7: "", Week8: "", Week9: "", Week10: "", Week11: "", Week12: "", Week13: "", Week14: "", Week15: "", Week16: "", Week17: "", Week18: "", Week19: "", Week20: "", Week21: "", Week22: "", Week23: "", Week24: "", Week25: "", Week26: "", Week27: "", Week28: "", Week29: "", Week30: "", Week31: "", Week32: "", Week33: "", Week34: "", Week35: "", Week36: "", Week37: "", Week38: "", Week39: "", Week40: "", Week41: "", Week42: "", Week43: "", Week44: "", Week45: "", Week46: "", Week47: "", Week48: "", Week49: "", Week50: "", Week51: "", Week52: "",
    },
  ];

  const csvData2 = [
    {
      productName: "Mango", productCode: "FT100", Week1: "100", Week2: "250", Week3: "300", Week4: "500", Week5: "440", Week6: "111", Week7: "750", Week8: "800", Week9: "340", Week10: "900", Week11: "667", Week12: "1000", Week13: "1100", Week14: "1422", Week15: "874", Week16: "988", Week17: "550", Week18: "1200", Week19: "680", Week20: "115", Week21: "3000", Week22: "2200", Week23: "1440", Week24: "678", Week25: "1670", Week26: "1700", Week27: "345", Week28: "678", Week29: "1800", Week30: "750", Week31: "880", Week32: "1700", Week33: "2400", Week34: "2500", Week35: "125", Week36: "990", Week37: "1560", Week38: "2650", Week39: "2700", Week40: "230", Week41: "2300", Week42: "1950", Week43: "2670", Week44: "3500", Week45: "3450", Week46: "3100", Week47: "1670", Week48: "545", Week49: "1880", Week50: "3220", Week51: "4540", Week52: "4444",
    },
  ];

  return (
    <>
      <LoadingComponent />
      <Page title="Surplus Bulk Upload  |  FAPS">
        <Container>
          <CommonPageHeader
            path="/dashboard"
            btname="Back"
            pageName={pageProps.pageheadername}
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer
              position="bottom-right"
              pauseOnHover
            />
            <Form autoComplete="off"
              disabled={!(formik.isValid && formik.dirty)}
              noValidate onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      size="small"
                      label="Date *"
                      openTo="day"
                      type="Date"
                      views={['year', 'month', 'day']}
                      value={Datevalue}
                      onChange={handleDateChange}
                      shouldDisableDate={shouldDisableDate}
                      renderInput={(params) => (
                        <TextField
                          width="100"
                          size="small"
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
                <br />
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button variant="contained" color='secondary' component="span"
                    disabled={formik.values.groupID == 0 || formik.values.operationEntityID == 0 ? true : false}>
                    <CSVReader
                      label={isFileChosen ? 'File Chosen' : 'Choose File'}
                      inputStyle={{ display: 'none' }}
                      onFileLoaded={handleForce}
                      parserOptions={papaparseOptions}
                      inputId="react-csv-reader-input"
                      cssClass="csv-reader-input"
                    />
                  </Button>

                  
                  {isFileChosen ? <span>{fileInfo.name}</span> : null}
                  
                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Surplus Bulk Template.csv"}
                    >
                      Template
                    </CSVLink>
                  </Button>

                  <Button variant="contained" color='primary' component="span">
                    <CSVLink
                      data={csvData2}
                      headers={csvHeaders}
                      style={{ color: 'white' }}
                      filename={"Surplus Bulk Upload Sample Template.csv"}
                    >
                      Sample Data
                    </CSVLink>
                  </Button>

                
                </Stack>
                <br />
                <Divider variant="middle" />
                <br />

                {duplicateCheck().length != 0 ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Typography variant="h7" gutterBottom>
                      Duplicate Surplus Count : {duplicateCheck().length}
                    </Typography>
                  </Stack> : null}


                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                    <Card style={{ justifycontent: 'center', width: '85rem' }} >
                      <TableContainer component={Paper} >
                        <Table aria-label="simple table">
                          
                          <TableHead>
                            <TableRow>
                              <TableCell rowSpan={2} align="center">Product Name</TableCell>
                              <TableCell rowSpan={2} align="center">Product Code</TableCell>
                              {weeks1.slice(0, 52).map((week, index) => (
                                <TableCell colSpan={1} align="center" key={index}>{`Week ${index + 1}`}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(rowsPerPage > 0
                              ? surplusBulkUpload.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              : surplusBulkUpload
                            ).map((row, index, array) => {
                              const isDuplicate = array.findIndex((item) => item.marketName === row.marketName && item.productCode === row.productCode) !== index;
                              return (
                                <TableRow
                                  key={row.marketName}
                                  style={{
                                    backgroundColor: isDuplicate ? '#FFEBEE' : 'inherit'
                                  }}
                                >
                                  <TableCell align="center">{row.productName}</TableCell>
                                  <TableCell align="center">{row.productCode}</TableCell>
                                  {weeks1.slice(0, 52).map((week, weekIndex) => (
                                    <TableCell
                                      align="center"
                                      key={weekIndex}
                                      style={{
                                        backgroundColor: isNaN(row[`week${weekIndex + 1}`]) || row[`week${weekIndex + 1}`] < 0 ? 'red' : 'inherit'
                                      }}
                                    >
                                      {row[`week${weekIndex + 1}`]}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              );
                            })}
                            {emptyRows > 0 && (
                              <TableRow style={{ height: 53 * emptyRows }}>
                                <TableCell colSpan={6} />
                              </TableRow>
                            )}
                          </TableBody>

                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                colSpan={6}
                                count={surplusBulkUpload.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    'aria-label': 'rows per page',
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Stack>
                  : <SearchNotFound searchQuery="Surplus Bulk Upload" />}
                {isTableEnable == false ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <LoadingButton
                      size="small"
                      type="button"
                      color='error'
                      variant="outlined"
                      disabled={pageProps.isEdit}
                      onClick={() => clearAll()}
                    >
                      Clear
                    </LoadingButton>
                    <LoadingButton
                      size="small"
                      type="submit"
                      color='secondary'
                      variant="outlined"
                      disabled={isTableEnable}
                    >
                      {pageProps.submitButtonName}
                    </LoadingButton>
                  </Stack> : null}
              </Stack>
            </Form>
          </FormikProvider>
        </Container>
      </Page >
    </>
  )
}
